import { UserStreams } from 'views/Streams/UserStreams/UserStreams';
import { UserChallenges } from 'views/Streams/UserChallenges/UserChallenges';
import { ChallengeLevelOne } from 'views/Streams/ChallengeLevelOne/ChallengeLevelOne';
import { StreamsEnroll } from 'views/Streams/StreamsEnroll/StreamsEnroll';
import { ChallengeKnowledgeCheck } from 'views/Streams/ChallengeKnowledgeCheck/ChallengeKnowledgeCheck';
import { ChallengeLevelOneInstructions } from 'views/Streams/ChallengeLevelOne/ChallengeLevelOneInstructions';
import { ChallengeKnowledgeCheckStart } from 'views/Streams/ChallengeKnowledgeCheck/ChallengeKnowledgeCheckStart';
import { StreamsPurchase } from 'views/Streams/UserStreams/StreamsPurchase';

const Routes = [
    {
        path: '/streams',
        view: UserStreams,
        layout: 'app',
        permission: 'streams.view',
        title: 'Streams.UserStreams.title',
    },
    {
        path: '/streams/:stream_id/challenges',
        view: UserChallenges,
        layout: 'app',
        permission: 'streams.challenges.view',
        title: 'Streams.UserChallenges.title'
    },
    {
        path: '/streams/:stream_id/challenges/:challenge_id/instructions',
        view: ChallengeLevelOneInstructions,
        layout: 'app',
        permission: 'streams.challenge.instructions.view',
        title: 'Streams.ChallengeLevelOne.ChallengeLevelOneInstructions.title'
    },
    {
        path: '/streams/:stream_id/challenges/:challenge_id',
        view: ChallengeLevelOne,
        layout: 'appPlain',
        permission: 'streams.challenge.view',
        title: 'Streams.ChallengeLevelOne.ChallengeLevelOne.title'
    },
    {
        path: '/challenges/:challenge_id/knowledge/:context',
        view: ChallengeKnowledgeCheck,
        layout: 'app',
        permission: 'streams.challenge.knowledge.view',
        title: `Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.title`
    },
    {
        path: '/streams/all',
        view: StreamsEnroll,
        layout: 'app',
        permission: 'streams.enroll.view',
        title: 'Streams.StreamsEnroll.title'
    },
    {
        path: '/streams/purchase',
        view: StreamsPurchase,
        layout: 'app',
        permission: 'streams.purchase.view',
        title: 'Streams.StreamsPurchase.title'
    },
    {
        path: '/streams/:stream_id/challenges/:challenge_id/knowledge/instructions',
        view: ChallengeKnowledgeCheckStart,
        layout: 'app',
        permission: 'streams.knowledge.instructions.view',
        title: 'Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheckStart.title'
    },
]

export default Routes;